import axios from "axios";
const Url = process.env.REACT_APP_API_URL;

export const NewsletterServ = async (email: any) => {
  const apiUrl = Url + "/news-letter";
  const response = await axios.post(apiUrl, { email: email });
  return response.data;
};

export const SendContact = async (obj: any) => {
  const apiUrl = Url + "/api/sendcontact";
  const response = await axios.post(apiUrl, obj);
  return response.data;
};

export const Contact = async (obj: any) => {
  const apiUrl = Url + "/api/sendcontact";
  const apiUrl1 = Url + "/api/add-contact";
  const response = await axios.post(apiUrl, obj);
  const response1 = await axios.post(apiUrl1, obj);
  return response.data;
};
